module.exports = __webpack_public_path__ + "media/images/banner/dmc/dmc-pc-31e29bee2082f48fe129549746d8068a.png";